module.exports = __webpack_public_path__ + "static/media/Ecommerce3.79aa3b5e.png";